import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  WithOptionsFilterFilters,
} from '@/src/components/organism/Filter/types';

export const noticeFilters: () => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = () => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
  },
  {
    key: 'createdAt',
    label: '등록 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['createdAtFrom', 'createdAtTo'],
  },
  {
    key: 'title',
    label: '제목',
    placeholder: '제목을 입력해주세요',
  },
  {
    key: 'adminName',
    label: '등록 관리자',
    placeholder: '관리자명을 입력해주세요',
  },
  {
    key: 'categoryType',
    label: '유형',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: '일반 공지', value: 'common' },
      { label: '커뮤니티 공지', value: 'community' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'showedYn',
    label: '노출 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: '노출', value: 'true' },
      { label: '미노출', value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'fixedTopYn',
    label: '우선 노출 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: '적용', value: 'true' },
      { label: '미적용', value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
];
